<template>
  <span>
    <span
      v-for="(item, itemIndex) in content.split(',')"
      :key="name + '-' + itemIndex"
    >
      <span
        class="badge badge-pill mx-1"
        :style="{ backgroundColor: getColor(item, name) }"
        >{{ item }}</span
      >
    </span>
  </span>
</template>
<script>
// Display types, tags of table
export default {
  name: "TableCellBadge",
  props: {
    content: String,
    getColor: Function,
    name: String,
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TableCellBadge.vue